function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { _optionalChain } from '@sentry/utils/esm/buildPolyfills';
import { logger } from '@sentry/utils';

/**
 * Express integration
 *
 * Provides an request and error handler for Express framework as well as tracing capabilities
 */
var Express = /*#__PURE__*/function () {
  /**
   * Express App instance
   */

  /**
   * @inheritDoc
   */
  function Express() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Express);
    ;
    Express.prototype.__init.call(this);
    this._router = options.router || options.app;
    this._methods = (Array.isArray(options.methods) ? options.methods : []).concat('use');
  }

  /**
   * @inheritDoc
   */
  _createClass(Express, [{
    key: "__init",
    value:
    /**
     * @inheritDoc
     */
    function __init() {
      this.name = Express.id;
    }
  }, {
    key: "setupOnce",
    value: function setupOnce() {
      if (!this._router) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('ExpressIntegration is missing an Express instance');
        return;
      }
      instrumentMiddlewares(this._router, this._methods);
    }
  }], [{
    key: "__initStatic",
    value:
    /**
     * @inheritDoc
     */
    function __initStatic() {
      this.id = 'Express';
    }
  }]);
  return Express;
}();
Express.__initStatic();

/**
 * Wraps original middleware function in a tracing call, which stores the info about the call as a span,
 * and finishes it once the middleware is done invoking.
 *
 * Express middlewares have 3 various forms, thus we have to take care of all of them:
 * // sync
 * app.use(function (req, res) { ... })
 * // async
 * app.use(function (req, res, next) { ... })
 * // error handler
 * app.use(function (err, req, res, next) { ... })
 *
 * They all internally delegate to the `router[method]` of the given application instance.
 */
function wrap(fn, method) {
  var arity = fn.length;
  switch (arity) {
    case 2:
      {
        return function (req, res) {
          var transaction = res.__sentry_transaction;
          if (transaction) {
            var span = transaction.startChild({
              description: fn.name,
              op: "express.middleware.".concat(method)
            });
            res.once('finish', function () {
              span.finish();
            });
          }
          return fn.call(this, req, res);
        };
      }
    case 3:
      {
        return function (req, res, next) {
          var transaction = res.__sentry_transaction;
          var span = _optionalChain([transaction, 'optionalAccess', function (_) {
            return _.startChild;
          }, 'call', function (_2) {
            return _2({
              description: fn.name,
              op: "express.middleware.".concat(method)
            });
          }]);
          fn.call(this, req, res, function () {
            _optionalChain([span, 'optionalAccess', function (_3) {
              return _3.finish;
            }, 'call', function (_4) {
              return _4();
            }]);
            for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
              args[_key] = arguments[_key];
            }
            next.call.apply(next, [this].concat(args));
          });
        };
      }
    case 4:
      {
        return function (err, req, res, next) {
          var transaction = res.__sentry_transaction;
          var span = _optionalChain([transaction, 'optionalAccess', function (_5) {
            return _5.startChild;
          }, 'call', function (_6) {
            return _6({
              description: fn.name,
              op: "express.middleware.".concat(method)
            });
          }]);
          fn.call(this, err, req, res, function () {
            _optionalChain([span, 'optionalAccess', function (_7) {
              return _7.finish;
            }, 'call', function (_8) {
              return _8();
            }]);
            for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
              args[_key2] = arguments[_key2];
            }
            next.call.apply(next, [this].concat(args));
          });
        };
      }
    default:
      {
        throw new Error("Express middleware takes 2-4 arguments. Got: ".concat(arity));
      }
  }
}

/**
 * Takes all the function arguments passed to the original `app` or `router` method, eg. `app.use` or `router.use`
 * and wraps every function, as well as array of functions with a call to our `wrap` method.
 * We have to take care of the arrays as well as iterate over all of the arguments,
 * as `app.use` can accept middlewares in few various forms.
 *
 * app.use([<path>], <fn>)
 * app.use([<path>], <fn>, ...<fn>)
 * app.use([<path>], ...<fn>[])
 */
function wrapMiddlewareArgs(args, method) {
  return args.map(function (arg) {
    if (typeof arg === 'function') {
      return wrap(arg, method);
    }
    if (Array.isArray(arg)) {
      return arg.map(function (a) {
        if (typeof a === 'function') {
          return wrap(a, method);
        }
        return a;
      });
    }
    return arg;
  });
}

/**
 * Patches original router to utilize our tracing functionality
 */
function patchMiddleware(router, method) {
  var originalCallback = router[method];
  router[method] = function () {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }
    return originalCallback.call.apply(originalCallback, [this].concat(_toConsumableArray(wrapMiddlewareArgs(args, method))));
  };
  return router;
}

/**
 * Patches original router methods
 */
function instrumentMiddlewares(router) {
  var methods = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  methods.forEach(function (method) {
    return patchMiddleware(router, method);
  });
}
export { Express };